import {
  PayrollOverviewsListingGetters,
  PayrollOverviewsListingActions,
  PayrollOverviewsListingMutations
} from '@/app/features/payroll-overviews/features/payroll-overviews-listing/payroll-overviews-listing.keys';
import { payrollOverviewsListingService as po } from '@/app/features/payroll-overviews/features/payroll-overviews-listing/payroll-overviews-listing.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';

import i18n from '@/i18n';
import router from '@/router';

export const getInitialState = () => {
  return {
    payrollOverviewsLoading: true,
    payrollOverviewsGenerationLoading: false,
    payrollOverviews: [],
    payrollOverviewsFilteredRecordCount: 0,
    processedTimeSheetCount: 0,
    searchParam: null,
    payrollOverviewsSortOrder: {
      sortBy: 'created_at',
      sortDirection: 'desc'
    },
    payrollOverviewsPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    }
  };
};

export const payrollOverviewsListingStore = {
  state: getInitialState(),
  getters: {
    [PayrollOverviewsListingGetters.PayrollOverviews]: state => {
      return state.payrollOverviews;
    },
    [PayrollOverviewsListingGetters.PayrollOverviewsGenerationLoading]: state => {
      return state.payrollOverviewsGenerationLoading;
    },
    [PayrollOverviewsListingGetters.PayrollOverviewsCount]: state => {
      return state.payrollOverviewsFilteredRecordCount;
    },
    [PayrollOverviewsListingGetters.PayrollOverviewsListingOffset]: state => {
      return state.payrollOverviewsPaginationParameters.offset;
    },
    [PayrollOverviewsListingGetters.PayrollOverviewsPerPage]: state => {
      return state.payrollOverviewsPaginationParameters.recordsPerPage;
    },
    [PayrollOverviewsListingGetters.PayrollOverviewsSortBy]: state => {
      return state.payrollOverviewsSortOrder.sortBy;
    },
    [PayrollOverviewsListingGetters.PayrollOverviewsSortDirection]: state => {
      return state.payrollOverviewsSortOrder.sortDirection;
    },
    [PayrollOverviewsListingGetters.PayrollOverviewsSortOrder]: state => {
      return state.payrollOverviewsSortOrder;
    },
    [PayrollOverviewsListingGetters.PayrollOverviewsPaginationParams]: state => {
      return state.payrollOverviewsPaginationParameters;
    },

    [PayrollOverviewsListingGetters.PayrollOverviewsIsLoading]: state =>
      state.payrollOverviewsLoading,

    [PayrollOverviewsListingGetters.ProcessedTimeSheetCount]: state => state.processedTimeSheetCount
  },
  mutations: {
    [PayrollOverviewsListingMutations.SetPayrollOverviewsLoading]: (state, loading = true) => {
      state.payrollOverviewsLoading = loading;
    },
    [PayrollOverviewsListingMutations.SetPayrollOverviewsGenerationLoading]: (
      state,
      loading = true
    ) => {
      state.payrollOverviewsGenerationLoading = loading;
    },
    [PayrollOverviewsListingMutations.SetPayrollOverviewsList]: (state, pos) => {
      state.payrollOverviews = pos;
    },
    [PayrollOverviewsListingMutations.SetPayrollOverviewsFilteredRecordCount]: (
      state,
      recordCount
    ) => {
      state.payrollOverviewsFilteredRecordCount = recordCount;
    },
    [PayrollOverviewsListingMutations.SetPayrollOverviewsSortOrder]: (state, sortOrder) => {
      state.payrollOverviewsSortOrder = sortOrder;
    },
    [PayrollOverviewsListingMutations.SetPayrollOverviewsFilters]: (state, filters) => {
      state.payrollOverviewsFilters = filters;
    },
    [PayrollOverviewsListingMutations.ResetPayrollOverviewsPaginationOffset]: state => {
      state.payrollOverviewsPaginationParameters.offset = 0;
    },
    [PayrollOverviewsListingMutations.SetPayrollOverviewsPaginationParameters]: (
      state,
      pagination
    ) => {
      state.payrollOverviewsPaginationParameters = pagination;
    },
    [PayrollOverviewsListingMutations.SetSearchParam]: (state, param) => {
      state.searchParam = param;
    },
    [PayrollOverviewsListingMutations.SetProcessedTimeSheetCount]: (state, data) => {
      state.processedTimeSheetCount = data;
    }
  },
  actions: {
    [PayrollOverviewsListingActions.UpdateProcessedTimeSheetCount]: ({ commit }, data) => {
      commit(PayrollOverviewsListingMutations.SetProcessedTimeSheetCount, data);
    },
    [PayrollOverviewsListingActions.RetrievePayrollOverviews]: ({ state, dispatch, commit }) => {
      commit(PayrollOverviewsListingMutations.SetPayrollOverviewsLoading);
      return po
        .retrievePayrollOverviews(
          state.payrollOverviewsSortOrder,
          state.payrollOverviewsPaginationParameters,
          state.searchParam
        )
        .then(result => {
          dispatch(PayrollOverviewsListingActions.RetrievePayrollOverviewsFilteredRecordCount);
          commit(PayrollOverviewsListingMutations.SetPayrollOverviewsList, result);
        })
        .then(() => {
          commit(PayrollOverviewsListingMutations.SetPayrollOverviewsLoading, false);
        });
    },
    [PayrollOverviewsListingActions.RetrievePayrollOverviewsFilteredRecordCount]: ({
      state,
      commit,
      dispatch
    }) => {
      return po
        .retrieveFilteredRecordCount(state.searchParam)
        .then(recordCount => {
          commit(
            PayrollOverviewsListingMutations.SetPayrollOverviewsFilteredRecordCount,
            recordCount
          );
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('payrollOverviews.listing.errors.retrievePos')
          });
          commit(PayrollOverviewsListingMutations.SetPayrollOverviewsLoading, false);
        });
    },
    [PayrollOverviewsListingActions.SetPayrollOverviewsSortOrder]: (
      { commit, dispatch },
      sortOrder
    ) => {
      commit(PayrollOverviewsListingMutations.SetPayrollOverviewsSortOrder, sortOrder);
      commit(PayrollOverviewsListingMutations.ResetPayrollOverviewsPaginationOffset);
      dispatch(PayrollOverviewsListingActions.RetrievePayrollOverviews);
    },
    [PayrollOverviewsListingActions.SetPayrollOverviewsFilters]: (
      { commit, dispatch },
      filters
    ) => {
      commit(PayrollOverviewsListingMutations.SetPayrollOverviewsFilters, filters);
      commit(PayrollOverviewsListingMutations.ResetPayrollOverviewsPaginationOffset);
      dispatch(PayrollOverviewsListingActions.RetrievePayrollOverviews);
    },
    [PayrollOverviewsListingActions.SetPayrollOverviewsPaginationParameters]: (
      { commit, dispatch },
      pagination
    ) => {
      commit(PayrollOverviewsListingMutations.SetPayrollOverviewsPaginationParameters, pagination);
      dispatch(PayrollOverviewsListingActions.RetrievePayrollOverviews);
    },
    [PayrollOverviewsListingActions.FilterListBySearchKey]: ({ commit, dispatch }, params) => {
      commit(PayrollOverviewsListingMutations.SetSearchParam, params.searchParam);

      if (!params.isSearchKey) {
        dispatch(PayrollOverviewsListingActions.RetrievePayrollOverviews);
      } else {
        commit(PayrollOverviewsListingMutations.ResetPayrollOverviewsPaginationOffset);
        commit(PayrollOverviewsListingMutations.SetPayrollOverviewsList, params.filteredItems);
        dispatch(PayrollOverviewsListingActions.RetrievePayrollOverviewsFilteredRecordCount);
      }
    },
    [PayrollOverviewsListingActions.ExportList]({ state }, actionParams) {
      let poPaginationParams = '';
      if (actionParams.menuOption === i18n.t('payrollOverviews.listing.actions.exportPage')) {
        poPaginationParams = state.payrollOverviewsPaginationParameters;
      }
      switch (actionParams.action) {
        case 'EXPORT TO EXCEL':
          return po.downloadExcel(
            state.payrollOverviewsSortOrder,
            poPaginationParams,
            state.searchParam
          );
        case 'EXPORT TO CSV':
          return po.downloadCSV(
            state.payrollOverviewsSortOrder,
            poPaginationParams,
            state.searchParam
          );
        case 'DOWNLOAD PDF':
          return po.downloadPDF(
            state.payrollOverviewsSortOrder,
            poPaginationParams,
            state.searchParam
          );
        case 'PRINT':
          return po.printPDF(
            state.payrollOverviewsSortOrder,
            poPaginationParams,
            state.searchParam
          );
      }
    },
    [PayrollOverviewsListingActions.GeneratePayrollOverview]: (
      { commit, dispatch },
      overviewParams
    ) => {
      commit(PayrollOverviewsListingMutations.SetPayrollOverviewsGenerationLoading);

      const auth = localStorage.getItem('tol-token');
      return po
        .generatePayrollOverview(overviewParams, auth)
        .then(res => {
          if (res.status && res.status !== 201) {
            dispatch(TolErrorsActions.SetError, { res, message: res.message });
          } else {
            router.push(`/payroll-overviews/${res.data}`);
          }
          commit(PayrollOverviewsListingMutations.SetPayrollOverviewsGenerationLoading, false);
        })
        .catch(err => {
          dispatch(TolErrorsActions.SetError, {
            err,
            message: i18n.t('payrollOverviews.listing.errors.generatePos')
          });
          commit(PayrollOverviewsListingMutations.SetPayrollOverviewsGenerationLoading, false);
        });
    }
  }
};
